import { Navigate } from 'react-router-dom';
import { useAuth } from '../../shared/useAuth.js';

function RootRedirect() {
  const ready = useAuth((s) => s.ready);
  const user = useAuth((s) => s.user);

  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-paper text-ink-3">
        جارِ التحميل...
      </div>
    );
  }
  return <Navigate to={user ? '/dashboard' : '/login'} replace />;
}

export default {
  path: '/',
  element: <RootRedirect />,
  protected: false,
  standalone: true,
  sidebar: null
};
